import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { convertTriggers, convertVisibleIf, q, v } from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setShowShareBtn,
  serial_num,
  isDkabio,
  setIsDkabio,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '驗證碼',
    placeholder: '0900000000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>回到首頁</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列
  // const visibleIfConditionsInit = {
  //   q1: '{q0} = 0',
  // }

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = convertVisibleIf({
    q38: '{q37} = 1',
    q39: '{q37} = 1',
    q40: '{q37} = 1',
  })

  // 非必填(從 0 計算)
  // const notRequired = [19]
  const notRequired = null

  // 尺規選項
  // const rateChoice = [
  //   { min: '(不是一個快樂的人)', max: '(是一個非常快樂的人)' },
  //   { min: '(比較不快樂)', max: '(比較快樂)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  // ]

  // const mappedRateChoice = rateChoice.map((v) => {
  //   return [
  //     {
  //       value: 1,
  //       text: '1 ' + v.min,
  //     },
  //     2,
  //     3,
  //     4,
  //     5,
  //     6,
  //     7,
  //     {
  //       value: 7,
  //       text: '7 ' + v.max,
  //     },
  //   ]
  // })
  const mappedRateChoice = null
  // const pageBreakQuestions = ['q2', 'q11', 'q15']
  const pageBreakQuestions = null
  const triggersConditionsInit = convertTriggers([
    {
      type: 'complete',
      expression:
        '({q1} = 1) or ({q1} = 2) or ({q1} = 3) or ({q1} = 4) or ({q1} = 5) or ({q1} = 6) or ({q1} = 8) or ({q1} = 9) or ({q1} = 10) or ({q1} = 12) or ({q1} = 13) or ({q1} = 14) or ({q1} = 15) or ({q1} = 16) or ({q1} = 17) or ({q1} = 18) or ({q1} = 19) or ({q1} = 20) or ({q1} = 21) or ({q1} = 22) or ({q2} = 1)',
    },
  ])

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    serial_num,
    bringOptionsMapRef,
    isDkabio,
    setIsDkabio,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)
  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
  }
  // useEffect(() => {
  //   console.log('temppppppplate', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  const canShowPrevButtonPages = null
  const endMessage = `<div>殘念…<br>目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，隨時得到最新活動消息。</div>`
  const defaultCompletionMessage = `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康!<br>點擊下方按鈕加入EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a> <a href="https://www.facebook.com/EasyCTRs" target="_blank">https://www.facebook.com/EasyCTRs</a><br><br>加入我們的<a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，隨時得到最新填問卷獲好禮的消息。</div>`

  const endSurveyMsg = (survey) => {
    const isTerminated =
      survey.getValue(q(1)) === v(1) ||
      survey.getValue(q(1)) === v(2) ||
      survey.getValue(q(1)) === v(3) ||
      survey.getValue(q(1)) === v(4) ||
      survey.getValue(q(1)) === v(5) ||
      survey.getValue(q(1)) === v(6) ||
      survey.getValue(q(1)) === v(8) ||
      survey.getValue(q(1)) === v(9) ||
      survey.getValue(q(1)) === v(10) ||
      survey.getValue(q(1)) === v(12) ||
      survey.getValue(q(1)) === v(13) ||
      survey.getValue(q(1)) === v(14) ||
      survey.getValue(q(1)) === v(15) ||
      survey.getValue(q(1)) === v(16) ||
      survey.getValue(q(1)) === v(17) ||
      survey.getValue(q(1)) === v(18) ||
      survey.getValue(q(1)) === v(19) ||
      survey.getValue(q(1)) === v(20) ||
      survey.getValue(q(1)) === v(21) ||
      survey.getValue(q(1)) === v(22) ||
      survey.getValue(q(2)) === v(1)

    setCompletionMessage(isTerminated ? endMessage : defaultCompletionMessage)
  }

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    setShowShareBtn,
    bringOptionsMapRef,
    endSurveyMsg,
  })

  // const completedPageElement = document.querySelector('.sd-completedpage')
  // useEffect(() => {
  //   if (completedPageElement) {
  //     setShowShareBtn(true)
  //     console.log('5566')
  //   }
  // }, [newSurvey])

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} />
      ) : myAgreeJson ? (
        <>
          <Survey model={agreeSurvey} />
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
